export enum AutoPopulateKeys {
    TITLE = 'title',
    SUBTITLE = 'subtitle',
    DOI = 'doi',
    RELATION_TITLE = 'relationTitle',
    IS_PART_OF_ISSN = 'isPartOfIssn',
    IS_PART_OF_ISSUE = 'isPartOfIssue',
    IS_PART_OF_VOLUME = 'isPartOfVolume',
    STATUS = 'status',
    PMID = 'pmid',
    ISSN = 'issn',
    EISSN = 'eissn',
    PUBLISHER = 'publisher',
    PEER_REVIEWED = 'peerReviewed',
    OPEN_ACCESS = 'openAccess',
    OPEN_ACCESS_STATUS = 'openAccessStatus',
    DESCRIPTION = 'description',
    METHODS = 'methods',
    COVERAGE = 'coverage',
    TECHNICAL_INFORMATION = 'technicalInformation',
    TITLE_ALTERNATIVE = 'titleAlternative',
    DATE = 'date',
    DATE_PUBLISHED = 'datePublished',
    DATE_PRESENTED = 'datePresented',
    DATE_COPYRIGHTED = 'dateCopyrighted',
    IS_PART_OF_EISSN = 'isPartOfEissn',
    IS_PART_OF_EISBN = 'isPartOfEisbn',
    ADDRESS = 'address',
    IS_PART_OF_ISBN_FOR_DISPLAY = 'isPartOfIsbnForDisplay',
    IS_PART_OF_DOI = 'isPartOfDoi',
    IS_PART_OF_PAGES = 'isPartOfPages',
    ISBN_FOR_DISPLAY = 'isbnForDisplay',
    PAGES = 'pages',
    EDITION = 'edition',
    SERIES = 'series',
    PUBLICATION_PLACE = 'publicationPlace',
    FORMAT = 'format',
    AUDIENCE = 'audience',
    CONFERENCE_NAME = 'conferenceName',
}
